module.exports = __webpack_public_path__ + "img/song.ac8be449.png";